import { useCallback, useEffect, useState } from "react";

const STORAGE_KEY = "jarvis_settings";

export interface JarvisSettings {
  voice: string;
  playbackRate: number;
  soundEffectsEnabled: boolean;
}

const DEFAULT_SETTINGS: JarvisSettings = {
  voice: "marin",
  playbackRate: 1,
  soundEffectsEnabled: true,
};

function loadSettings(): JarvisSettings {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return DEFAULT_SETTINGS;
    return { ...DEFAULT_SETTINGS, ...(JSON.parse(raw) as Partial<JarvisSettings>) };
  } catch {
    return DEFAULT_SETTINGS;
  }
}

export function useSettings() {
  const [settings, setSettings] = useState<JarvisSettings>(() => loadSettings());

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(settings));
    } catch {
      // ignore
    }
  }, [settings]);

  const updateSettings = useCallback((patch: Partial<JarvisSettings>) => {
    setSettings((current) => ({ ...current, ...patch }));
  }, []);

  return { settings, updateSettings };
}
